import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from '@fino-ui/button';
import { SubmittableForm } from '@fino-ui/forms';
import { FinoInputModule } from '@fino-ui/input';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';

@Component({
  selector: 'app-kwh-deactivate',
  templateUrl: './deactivate.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslationModule,
    FormsModule,
    ReactiveFormsModule,
    FinoInputModule,
    ButtonModule,
  ],
})
export class KWHDeActivateComponent
  extends BaseModalComponent<{ isAidServiceActive: boolean }, boolean>
  implements OnInit
{
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  form = new SubmittableForm({});

  isAidServiceActive: boolean;

  ngOnInit(): void {
    if (this.isAidServiceActive) {
      this.form.addControl(
        'accessOnlyForAdmins',
        new FormControl(null, [Validators.requiredTrue]),
      );
      this.form.addControl(
        'activesGetCancelled',
        new FormControl(null, [Validators.requiredTrue]),
      );

      this.form.addControl(
        'faxRedirect',
        new FormControl(null, [Validators.requiredTrue]),
      );
    }
  }

  abort() {
    this.close();
  }

  get title() {
    return `kwh.${!this.isAidServiceActive ? 'activate' : 'deactivate'}.title`;
  }

  get subtitle() {
    return `kwh.${!this.isAidServiceActive ? 'activate' : 'deactivate'}.subtitle`;
  }

  get submitLabel() {
    return `kwh.${!this.isAidServiceActive ? 'activate' : 'deactivate'}.submit`;
  }

  get hint() {
    return `kwh.${!this.isAidServiceActive ? 'activate' : 'deactivate'}.hint`;
  }

  submit() {
    this.result = true;
    this.close();
  }
}
